import Service from "../Service";

const resource = "ServiceOrderActivities/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID },
    });
  },
  save(obj, requestID) {
    return Service.post(resource + "save", obj, {
      params: { requestID },
    });
  },
  paginationEvidence(parameters, requestID) {
    return Service.post(resource + "paginationEvidence", parameters, {
      params: { requestID },
    });
  },
  saveEvidence(parameters, requestID) {
    return Service.post(resource + "saveEvidence", parameters, {
      params: { requestID },
    });
  },
};
